export default "__VITE_ASSET__CaRDVD0O__"